







import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";

@Component
export default class ValSummary extends Vue {
    @Prop({ required: true, default: () => [] })
    errors!: string[];

    localErrors: string[] = this.errors;

    mounted() {
        this.$root.$on("validate", (errors: string[]) => {
            this.localErrors = errors;
        });
    }
}
